
if( document.querySelectorAll('.block_product-details').length > 0){  

  let productDetailsClose = document.querySelector(".block_detail-popup-close");
   productDetailsClose.addEventListener("click", (event) => {
      let target = event.target;
      document.querySelector(".block_detail-popup").classList.toggle("hidden");   
      document.querySelector("body").classList.remove("over-hidden-open");
      setTimeout( () => {
          document.querySelector("body").classList.remove("over-hidden");
      }, 10)	
  })
	
	
	document.addEventListener('click', function(e) {
		let container = document.querySelector('.block_detail-popup-inner');
		let container2 = document.querySelector('.block_product-details');
		let container3 = document.querySelector('.block_product-tellus-text-icon-text');
	   let container4 = document.querySelector('.block_open-box-popup-inner');
	
		let target = e.target;
		if(e.target.classList.contains("block_product-details") == true){
			document.querySelector("body").classList.add("over-hidden");
		}
	
		if (!container.contains(target) && !container2.contains(target)) {
			let isContainerClicked = target.classList.contains('.block_detail-popup .block_detail-popup-inner');      
			let isDescendantClicked = container.contains(target);         
			if (!isContainerClicked && !isDescendantClicked && !container2.contains(target)  ) {  
				let kalviyoElements = document.querySelectorAll('.block_detail-popup');
				kalviyoElements.forEach(function(element) {
					element.classList.add('hidden');
					document.querySelector("body").classList.remove("over-hidden");
					document.querySelector(".block_detail-popup").classList.add("hidden");  
				   
				});
			}
		}
	});
}